import { useQuery } from '@apollo/client';
import { Flex } from '@firsttable/web-components/atoms';
import Box from '@firsttable/web-components/atoms/Box';
import themeGet from '@firsttable/web-theme/themeGet';
import BodyTitle from '@firsttable/web-components/atoms/BodyTitle';
import Text from '@firsttable/web-components/atoms/Text';
import React, { type ReactNode } from 'react';
import { GET_LOYALTY_TIERS } from './loyaltyQueries';
import { ErrorHandler } from '../ErrorBoundary/ErrorBoundary';

const LoyaltyTierDetailsAccordion = ({
  renderHtml,
}: {
  renderHtml: (html: string) => ReactNode;
}) => {
  const { data, loading, error } = useQuery(GET_LOYALTY_TIERS, {
    variables: {
      siteId: process.env.NEXT_PUBLIC_SITE_ID,
    },
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <ErrorHandler error={error} />;
  }

  return (
    <Flex flexDirection="column" gridGap={40}>
      {data.tiers.map((tier) => (
        <Box key={tier.id}>
          <Flex
            justifyContent="space-between"
            alignContent="center"
            color="white"
            background={themeGet(`colors.loyalty.${tier.title.toLowerCase()}`)}
            px="l"
            py="s"
            borderTopLeftRadius={2}
            borderTopRightRadius={2}>
            <BodyTitle as="h4" size="s" m={0}>
              {tier.title}
            </BodyTitle>
            <Text m={0}>{tier.pointsRequiredToUpgrade.toLocaleString('en-US')} points</Text>
          </Flex>
          <Box
            border="1px solid"
            borderColor="grayscale.300"
            borderBottomLeftRadius={2}
            borderBottomRightRadius={2}
            p={['m', 'l']}
            pb={['xs', 's']}>
            {renderHtml(tier.description)}
            <dl>
              {tier.benefits.map((benefit) => (
                <React.Fragment key={benefit.title + benefit.customValue}>
                  <BodyTitle as="h5" size="s" mb={10}>
                    <Text as="span">{benefit.title}</Text>
                    {benefit.customValue && (
                      <Text as="small" fontWeight={400} fontSize="s">
                        {': '}
                        {benefit.customValue}
                      </Text>
                    )}
                  </BodyTitle>
                  {renderHtml(benefit.description)}
                </React.Fragment>
              ))}
            </dl>
          </Box>
        </Box>
      ))}
    </Flex>
  );
};

export default LoyaltyTierDetailsAccordion;
